import React from 'react';
import { AlertCircle, RotateCcw, ArrowLeftRight, CheckCircle, Package, Clock } from 'lucide-react';

// Status badge config (workflow states)
const statusConfig = {
  pending: {
    label: 'Pending',
    bg: 'bg-status-pending',
    icon: Clock,
  },
  failed: {
    label: 'Failed',
    bg: 'bg-status-error',
    icon: AlertCircle,
  },
  completed: {
    label: 'Completed',
    bg: 'bg-status-success',
    icon: CheckCircle,
  },
};

// Order type badge config
const orderTypeConfig = {
  standard: {
    label: 'Standard',
    bg: 'bg-status-info',
    icon: Package,
  },
  return: {
    label: 'Return',
    bg: 'bg-status-return',
    icon: RotateCcw,
  },
  exchange: {
    label: 'Exchange',
    bg: 'bg-status-warning',
    icon: ArrowLeftRight,
  },
};

export default function StatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig.pending;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-white text-sm font-medium ${config.bg}`}
    >
      <Icon size={14} />
      {config.label}
    </span>
  );
}

export function OrderTypeBadge({ orderType }) {
  const config = orderTypeConfig[orderType] || orderTypeConfig.standard;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-white text-sm font-medium ${config.bg}`}
    >
      <Icon size={14} />
      {config.label}
    </span>
  );
}
